import { MarketingLayout } from "../components/MarketingLayout";

export default function LegalPage({ title, children, path }) {
  return (
    <MarketingLayout>
      <article className="max-w-prose mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="marquee-tag mb-4">// LEGAL</div>
        <h1 className="font-display font-black type-title-lg tracking-tighter mb-8">{title.toUpperCase()}</h1>
        <div className="text-sm text-ink-muted leading-relaxed space-y-4">{children}</div>
        <p className="text-xs text-ink-subtle mt-12">Last updated: July 9, 2026. Contact: legal@cloudcraftlabs.com</p>
      </article>
    </MarketingLayout>
  );
}

export function Privacy() {
  return (
    <LegalPage title="Privacy Policy" path="/privacy">
      <p>DemoCraft (&quot;we&quot;, &quot;us&quot;) is operated by CloudCraft Labs. This policy describes how we handle your data.</p>
      <h2 className="font-display font-bold type-heading tracking-tight mt-8 mb-2">What we collect</h2>
      <p>Account information (name, email), uploaded product assets (screenshots, audio, recordings), project metadata, and usage analytics when enabled.</p>
      <h2 className="font-display font-bold type-heading tracking-tight mt-8 mb-2">How we use data</h2>
      <p>To provide demo generation, store your projects, process billing, and improve the service. AI providers process content only to fulfill generation requests.</p>
      <h2 className="font-display font-bold type-heading tracking-tight mt-8 mb-2">Your content</h2>
      <p>You retain ownership of all uploads and generated outputs. You control exports and public share links. Delete projects anytime to remove associated files.</p>
      <h2 className="font-display font-bold type-heading tracking-tight mt-8 mb-2">Data retention</h2>
      <p>Projects persist until you delete them. Configure UPLOAD_RETENTION_DAYS for automatic cleanup of stale drafts on self-hosted deployments.</p>
      <h2 className="font-display font-bold type-heading tracking-tight mt-8 mb-2">Third parties</h2>
      <p>We may use Stripe (billing), Resend/SMTP (email), and AI providers you configure. Self-hosted deployments control which services connect.</p>
    </LegalPage>
  );
}

export function Terms() {
  return (
    <LegalPage title="Terms of Service" path="/terms">
      <p>By using DemoCraft you agree to these terms. If you disagree, do not use the service.</p>
      <h2 className="font-display font-bold type-heading tracking-tight mt-8 mb-2">Service</h2>
      <p>DemoCraft provides AI-assisted demo video and documentation generation. Features vary by plan. We may update the service with notice.</p>
      <h2 className="font-display font-bold type-heading tracking-tight mt-8 mb-2">Acceptable use</h2>
      <p>Do not upload illegal content, infringe others&apos; IP, or abuse rate limits. You are responsible for content you upload and share.</p>
      <h2 className="font-display font-bold type-heading tracking-tight mt-8 mb-2">Billing</h2>
      <p>Paid plans renew monthly. Refunds follow our standard policy. Downgrade anytime; usage limits apply immediately.</p>
      <h2 className="font-display font-bold type-heading tracking-tight mt-8 mb-2">Disclaimer</h2>
      <p>AI outputs may contain errors. Review before publishing. Service provided &quot;as is&quot; without warranty.</p>
    </LegalPage>
  );
}

export function Security() {
  return (
    <LegalPage title="Security" path="/security">
      <p>DemoCraft is built with security-first defaults for a SaaS handling sensitive product assets.</p>
      <h2 className="font-display font-bold type-heading tracking-tight mt-8 mb-2">Authentication</h2>
      <p>Cookie-based sessions with CSRF protection. JWT for API clients. Production requires COOKIE_SECURE and explicit CORS_ORIGINS.</p>
      <h2 className="font-display font-bold type-heading tracking-tight mt-8 mb-2">Storage</h2>
      <p>Uploads stored in isolated per-project directories (local volume or MinIO). Private by default; public only via explicit share tokens.</p>
      <h2 className="font-display font-bold type-heading tracking-tight mt-8 mb-2">AI processing</h2>
      <p>Content sent to configured AI providers for generation. Use mock/demo mode before connecting production providers. We do not sell your data.</p>
      <h2 className="font-display font-bold type-heading tracking-tight mt-8 mb-2">Your controls</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>Delete projects and uploaded assets anytime</li>
        <li>Export your content in standard formats</li>
        <li>Bring your own API keys for AI providers</li>
        <li>Self-host with Docker for full data control</li>
      </ul>
    </LegalPage>
  );
}

export function Contact() {
  return (
    <LegalPage title="Contact" path="/contact">
      <p>We&apos;d love to hear from you — beta feedback, agency partnerships, or enterprise inquiries.</p>
      <p><strong>Email:</strong> hello@cloudcraftlabs.com</p>
      <p><strong>Product support:</strong> support@cloudcraftlabs.com</p>
      <p><strong>Security:</strong> security@cloudcraftlabs.com</p>
      <p className="mt-6">For beta access, <a href="/register" className="text-ink-accent underline">create a free account</a> — 3 demo projects included.</p>
    </LegalPage>
  );
}
